import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import useStyles from './styles';

interface Props {
  text?: string;
  center?: boolean;
  contentSize?: boolean;
}

const Loading: React.FC<Props> = ({ text, center, contentSize }) => {
  const classes = useStyles();
  return text ? (
    <Grid container alignItems="center">
      <Grid item justifyContent={center ? 'center' : 'flex-start'}>
        <CircularProgress />
      </Grid>
      <Grid item>
        <Typography variant="subtitle1">{text}</Typography>
      </Grid>
    </Grid>
  ) : (
    <Box className={classes.contentSize} textAlign={center || contentSize ? 'center' : 'left'}>
      <CircularProgress />
    </Box>
  );
};

export default Loading;
